// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".eopoi-widget .poi-social-btn__wrapper .poi-social-btn{height:40px;width:150px}", ""]);
// Exports
module.exports = exports;
